import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { Loading } from '@planne-software/uni';

import { directLinkStateSelector } from '@src/stores/directLink';
import { DirectLinkType, LEGACY_PAYMENT_DIRECT_LINK_TYPES } from '@src/domains/direct-links';

import Container from '@src/components/reusable/Container';

import Error from '@src/components/DirectLink/Error';
import FeatureFlag from '@src/components/FeatureFlag';
import Payment from '@src/components/DirectLink/Payment';
import SalePreview from '@src/components/DirectLink/SalePreview';
import { useCartLinkError } from '@src/features/direct-link/availability';

/** The new checkout signs the buyer in and shows the cart in its summary, so the link goes straight to it. */
const CartLinkCheckoutEntry = () => {
  const error = useCartLinkError();

  return error ? <Error>{error}</Error> : <Navigate to='checkout' replace />;
};

const CartLink = () => (
  <FeatureFlag
    feature='PR-3043-checkout'
    pending={() => <Loading size='lg' />}
    active={() => <CartLinkCheckoutEntry />}
    fallback={() => <SalePreview showErrors={false} />}
  />
);

export const Home = () => {
  const { directLink } = useSelector(directLinkStateSelector);

  return (
    <Container>
      {directLink?.type === DirectLinkType.Cart ? <CartLink /> : null}

      {LEGACY_PAYMENT_DIRECT_LINK_TYPES.includes(directLink?.type ?? '') ? <Payment /> : null}
    </Container>
  );
};

export default Home;
